import React, { useContext } from "react";
import EditIcon from "@mui/icons-material/Edit";
import AuthContext from "../../../context/AuthContext";
import LoadEnrollmentInProgressTable from "./LoadEnrollmentInProgressTable";
import { DeleteIconStyled } from "./LoadEnrollment.styles";

/**
 * Incomplete merchant enrollments for the current user (In Progress tab).
 */
const LoadEnrollment = (props) => {
  const { setSubmenuMerchantTerminal, setSelectedOption, setNameSection } =
    props;
  const { acquirerData } = useContext(AuthContext);

  const enrollmentType = !acquirerData?.isoID
    ? "MERCHANT_ACQUIRER"
    : "MERCHANT_ISO";

  const columns = [
    { id: "acquirerId", label: "Merchant ID" },
    { id: "acquirerName", label: "Merchant Name" },
    { id: "acquirerEmail", label: "Merchant Email" },
    {
      id: "enrollment_completed",
      label: "Status",
      format: (value) => (value ? "Completed" : "Pending"),
    },
    {
      id: "action",
      label: "Actions",
      actions: [
        {
          icon: <EditIcon />,
          label: "Set to Complete",
          onClick: () => {},
        },
        {
          icon: <DeleteIconStyled />,
          label: "Delete",
          onClick: () => {},
        },
      ],
    },
  ];

  return (
    <LoadEnrollmentInProgressTable
      title="Incomplete Enrollments"
      enrollmentType={enrollmentType}
      columns={columns}
      deleteLabelField="acquirerId"
      searchPlaceholder="Merchant ID, name, or email"
      onContinue={() => {
        setSubmenuMerchantTerminal("enrollment");
        setSelectedOption("merchant_terminal_new");
        setNameSection("Merchant & Terminal - Enrollment");
      }}
    />
  );
};

export default LoadEnrollment;
